// firebaseConfig.js
// This file provides Firebase configuration for both development and production

// Hard-coded config for production to ensure it works on Vercel
const prodConfig = {
  apiKey: "AIzaSyD4xs8OV0yV0sGOOC74O2ZjXtN63SRN_dI",
  authDomain: "askaway-b6943.firebaseapp.com",
  projectId: "askaway-b6943",
  storageBucket: "askaway-b6943.firebasestorage.app",
  messagingSenderId: "406044685882",
  appId: "1:406044685882:web:a02cef0ccdc2057ee2e703",
  measurementId: "G-TY3B30FS6H"
};

// Support both naming conventions: REACT_APP_ (for CRA) and NEXT_PUBLIC_ (for Vercel)
// Fall back to hard-coded values if environment variables are not available
export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || process.env.NEXT_PUBLIC_FIREBASE_API_KEY || prodConfig.apiKey,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN || prodConfig.authDomain,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID || prodConfig.projectId,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET || prodConfig.storageBucket,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID || prodConfig.messagingSenderId,
  appId: process.env.REACT_APP_FIREBASE_APP_ID || process.env.NEXT_PUBLIC_FIREBASE_APP_ID || prodConfig.appId,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID || prodConfig.measurementId,
  webClientId: "406044685882-f7aj0aafs6usfhilg6a55a9g90hqnfk6.apps.googleusercontent.com"
};

// Note: Firebase configuration for client-side code will always be visible in the browser
// This is expected and normal for Firebase web applications
// Keep truly sensitive keys like service account credentials on the server only 